import { gql } from '@apollo/client';

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    user {
      id
      fullName
      email
      currentOrganization {
        id
        name
        initialProjects {
          id
          name
          topic
        }
        personaAccessTypes
      }
      tosVerified
      hasOnboarded
      canCreateProject
    }
  }
`;
